<!--
 * Created by JackCui on 2021/12/2
 -->
<script>
export default {
  name: 'header-render',
  props: {
    node: Object
  },
  render (h) {
    const { props, buttons } = this.node
    return (
      <f-header {...{ props }}>
        {buttons && <buttons-render slot="inner" node={this.node} />}
      </f-header>
    )
  }
}
</script>
